import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type IntervinienteViewStylesType = {
  wrapperHeader: SxProps
  header: SxProps
  headerTitle: SxProps
  form: SxProps
}

export const intervinienteViewStyles: IntervinienteViewStylesType = {
  wrapperHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: 'white',
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1.5)
  },

  header: {
    backgroundColor: theme.colors.blue07,
    height: 50,
    padding: theme.spacing(0, 2, 0, 3),
    margin: theme.spacing(3, 0, 1, 0)
  },

  headerTitle: {
    height: 20,
    color: theme.colors.blue02,
    fontFamily: theme.corporate.primaryFont,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },

  form: {
    borderRadius: '8px',
    border: `1px solid ${theme.colors.gray600}`,
    padding: theme.spacing(3.25, 2)
  }
}
